// @ts-ignore
require('./polyfills/requestAnimationFrame.js');

// JQuery, and Animation Code
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

// var $win = $(window);
// var $body = $(document.body);

// @ts-ignore
require('./lib/a4jAjaxEvents.js');
// @ts-ignore
require('./site/testimonialScroll.js');

// @ts-ignore
var MobileMenu = require('./site/MobileMenu.js');
MobileMenu.init();

// @ts-ignore
var Forms = require('./lib/Forms.js');
Forms.init();

// Google Adwords phone number tracking setup
// @ts-ignore
var CallTracking = require('./site/CallTracking.js');
CallTracking.init();


import CollapsableGroup from './component/CollapsableGroup/CollapsableGroup';
new CollapsableGroup();
